

export const PAGINATION = {
  page: 1,
  size: 10
};
